import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            name: null,
            email: null,
            token: null
        },
        course: {}
    },
    mutations: {
        setUserToken(state, value) {
            state.user.token = value
        },
        setUserEmail(state, value) {
            state.user.email = value
        },
        setCourse(state, value) {
            state.course = value
        },
        setLessonCompleted(state, id) {
            if (state.course) {
                state.course.lections.forEach(lesson => {
                    if (lesson.id == id && lesson.progress) {
                        lesson.progress.id = 3
                    }
                })
            }
        }
    },
    getters: {
        user: state => state.user,
        course: state => state.course
    },
    actions: {

    }
})
